import { msg } from '@lingui/core/macro';
import { APP_PATHS } from 'app-shared/constants';
import {
  IconCalendar,
  IconColorSwatch,
  IconCreditCard,
  IconSettings,
  IconShield,
  IconUser,
  IconUsers,
} from 'app-ui/icon';

import { AUTH_MODE } from '@/auth/constants/AuthMode';
import { type NavigationSection } from '@/navigation/types/NavigationSection';

// The settings pages, in drawer order. The command menu reads this list too.
export const SETTINGS_NAVIGATION_SECTIONS: NavigationSection[] = [
  {
    id: 'account',
    title: msg`Account`,
    items: [
      {
        id: 'profile',
        label: msg`Profile`,
        Icon: IconUser,
        path: APP_PATHS.settingsProfile,
      },
      // Passwords and devices exist only with Clerk sign-in.
      ...(AUTH_MODE === 'clerk'
        ? [
            {
              id: 'security',
              label: msg`Security`,
              Icon: IconShield,
              path: APP_PATHS.settingsSecurity,
            },
          ]
        : []),
      {
        id: 'appearance',
        label: msg`Appearance`,
        Icon: IconColorSwatch,
        path: APP_PATHS.settingsAppearance,
      },
    ],
  },
  {
    id: 'workspace',
    title: msg`Workspace`,
    items: [
      {
        id: 'workspace-general',
        label: msg`General`,
        Icon: IconSettings,
        path: APP_PATHS.settingsWorkspace,
      },
      {
        id: 'planning',
        label: msg`Working hours`,
        Icon: IconCalendar,
        path: APP_PATHS.settingsPlanning,
        permission: 'org:reference-data:edit',
      },
      {
        id: 'team',
        label: msg`Team`,
        Icon: IconUsers,
        path: APP_PATHS.settingsTeam,
      },
      {
        id: 'teams-and-skills',
        label: msg`Teams and skills`,
        Icon: IconUsers,
        path: APP_PATHS.settingsTeamsAndSkills,
      },
      {
        id: 'intervention-types',
        label: msg`Intervention types`,
        Icon: IconColorSwatch,
        path: APP_PATHS.settingsInterventionTypes,
      },
      {
        id: 'members',
        label: msg`Members`,
        Icon: IconUsers,
        path: APP_PATHS.settingsMembers,
      },
      {
        id: 'billing',
        label: msg`Billing`,
        Icon: IconCreditCard,
        path: APP_PATHS.settingsBilling,
      },
    ],
  },
];
